import { gql } from '@apollo/client';

// CONTRACT: password-Feld BEWUSST ausgeschlossen — Bcrypt-Hashes dürfen nicht in den Apollo-Cache.
// Nur schema-sichere Felder nach Benutzeranlage zurückfragen. Parallel zu getAllUser.ts.
const createUser = gql`
  mutation ($input: CreatUser!) {
    registUser(input: $input) {
      username
      first_name
      last_name
      email
      enabled
      roles
    }
  }
`;
export default createUser;
